import { makeStyles } from '@material-ui/styles';

const styles = makeStyles(() => ({
    snackbar: {
        zIndex: 10000,
    },
}));

export default styles;
